import { useEffect, useState } from 'react'
import Card from '../components/Card'
import CardGrid from '../components/CardGrid'
import Hero from '../components/Hero'
import { useNavigate } from 'react-router-dom'
import { fetchWithLanguage } from '../../util/fetchFunction'
import CardCategory from '../components/CardCategory'
import { useTranslation } from 'react-i18next'
import { languageUtil } from '../../util/languageUtils'
import { LoadingOverlay } from '../../shared/components/Loading'

export default function Projects() {
    const [news, setNews] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(true)
    const navigate = useNavigate()
    const { t } = useTranslation()
    const { language } = languageUtil()
    const rtl = language === 'ar'

    useEffect(() => {
        const fetchNews = async () => {
            await fetchWithLanguage(`get-all-projects`, setNews, setError, setLoading)
        }
        // const fetchCategories = async () => {
        //     await fetchWithLanguage(`get-list-projects`, setCategories, setError, setLoading, {
        //         transform: items =>
        //             items.map(item => ({
        //                 label: item.title,
        //                 value: item.id,
        //             })),
        //     })
        // }

        fetchNews()
        // fetchCategories()
    }, [language])

    const renderCard = item =>
        item.is_active === 1 || item.is_active === '1' ? (
            <Card
                key={item.id}
                label={rtl ? item.title_ar : item.title_en || item.title}
                description={rtl ? item.subtitle_ar : item.subtitle_en || item.subtitle}
                imageSrc={item.image_preview || item.header_image}
                category={[item.project_category_name]}
                buttonLabel={
                    rtl ? item.call_to_action_ar : item.call_to_action_en || item.call_to_action
                }
                onButtonClick={() => navigate(`/projects/${item.id}`)}
            >
                {/* <span className='inline-block px-3 py-1 mb-2 text-xs font-medium text-yellow-800 bg-yellow-200 rounded-full'>
                    {item.project_category_name}
                </span>
                <h3>{item.title}</h3>
                <span className='text-sm text-gray-500'>{item.subtitle}</span> */}
                <p>
                    {rtl
                        ? item.small_description_ar
                        : item.small_description_en || item.small_description}
                </p>
            </Card>
        ) : null

    return (
        <div>
            <Hero title={t('projects.title')} imageUrl='/img/banners/projects.jpeg' size='large' />
            <div className='mx-auto my-8 max-w-7xl'>
                {loading ? (
                    <LoadingOverlay message={t('loading')} />
                ) : (
                    // <p className='text-center text-gray-500'>{t('loading')}</p>
                    <div>
                        <CardCategory
                            data={news}
                            renderCard={renderCard}
                            // filters={[
                            //     {
                            //         label: 'Categories',
                            //         placeholder: 'Select project categories',
                            //         options: categories,
                            //         onChange: value => {
                            //             console.log('Custom handler for category:', value)
                            //         },
                            //     },
                            // ]}
                        />
                    </div>
                )}
            </div>
        </div>
    )
}
